export function RefreshIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M2.6665 2.66675V6.00008H3.05418M13.2919 7.33341C12.9638 4.70254 10.7196 2.66675 7.99984 2.66675C5.76159 2.66675 3.84536 4.04553 3.05418 6.00008M3.05418 6.00008H5.99984M13.3332 13.3334V10.0001H12.9455M12.9455 10.0001C12.1543 11.9546 10.2381 13.3334 7.99984 13.3334C5.28009 13.3334 3.03583 11.2976 2.70777 8.66675M12.9455 10.0001H9.99984'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
